 
import clsx from 'clsx'
import {FC} from 'react'
import {BlogCategory} from '../../core/_models'
import {useNavigate} from 'react-router-dom'
import _ from 'lodash'
type Props = {
  blogCategory: BlogCategory
}

const InfoCell: FC<Props> = ({blogCategory}) => {
  const navigate = useNavigate()
  const viewAllBusinessHandler = () => {
    navigate(`/blogs/${blogCategory.id}/${blogCategory.slug}`)
  }
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a
          onClick={viewAllBusinessHandler}
          className='text-gray-800 text-hover-primary mb-1 pointer'
        >
          {blogCategory?.name}
        </a>
      </div>
    </div>
  )
}

export {InfoCell}
